import { useEffect } from 'react'
import { eventEmitterStore } from 'entities/EventEmitter/store/EventEmitterStore'
import {
  type IEventEmitterActionKeys,
  type IEventEmitterCallback,
} from 'entities/EventEmitter/store'

export function useEventEmitter<E extends IEventEmitterActionKeys>(
  eventName: E,
  callback: IEventEmitterCallback<E>
) {
  useEffect(() => {
    eventEmitterStore.subscribe(eventName, callback)

    return () => {
      eventEmitterStore.unsubscribe(eventName, callback)
    }
  }, [])
}
